import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Phone, CheckCircle2 } from 'lucide-react';
import { LOGO, PHONE_NUMBER, PHONE_TEL_HREF } from '../../constants/site';

export const OpenHouseThankYou = ({ name }) => (
  <div className="text-center py-10 space-y-4" data-testid="open-house-success">
    <CheckCircle2 className="w-20 h-20 text-green-500 mx-auto" />
    <h2 className="text-3xl font-serif font-black text-gray-900">Thank you, {name.split(' ')[0]}!</h2>
    <p className="text-gray-600 text-lg">You're signed in. Enjoy the tour — Jess will follow up shortly.</p>
  </div>
);

export const OpenHouseHeader = () => (
  <header className="flex items-center justify-between px-5 py-4">
    <Link to="/" className="flex items-center space-x-3" data-testid="open-house-home-link">
      <img src={LOGO} alt="Jess Sells East Coast" className="h-12 w-auto" style={{ filter: 'brightness(0) invert(1) sepia(1) saturate(5) hue-rotate(180deg)' }} />
    </Link>
    <a href={PHONE_TEL_HREF} className="flex items-center space-x-2 text-gold-400 font-bold text-sm sm:text-base">
      <Phone className="w-4 h-4" /><span>{PHONE_NUMBER}</span>
    </a>
  </header>
);

// Gold-bordered card with the sign-in title; children = form or thank-you.
export const OpenHouseCard = ({ property, children }) => (
  <div className="w-full max-w-lg relative">
    <div className="absolute -inset-4 bg-gold-400/20 blur-3xl rounded-3xl"></div>
    <div className="relative bg-sand-50 rounded-3xl shadow-2xl border-4 border-gold-400/60 p-6 sm:p-10">
      <div className="text-center mb-6 pb-5 border-b-2 border-gold-400/30">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-gold-400 to-gold-600 rounded-2xl shadow-xl mb-3">
          <Home className="w-8 h-8 text-white" />
        </div>
        <h1 className="text-3xl sm:text-4xl font-serif font-black text-gray-900">Open House Sign-In</h1>
        {property && <p className="mt-2 text-base font-bold text-[#143160]" data-testid="open-house-property">{property}</p>}
        <p className="text-sm text-gray-500 mt-1">Welcome! Please sign in so Jess can follow up with details on this home.</p>
      </div>
      {children}
    </div>
  </div>
);
